//import components
import mainnav from '@/components/_globals/mainnav/mainnav.vue'

//import swiper plugin
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

//import json data
import news from '@/assets/json/news/news.json'
import categories from '@/assets/json/news/categories.json'

export default {
  name: 'news-article',
  components: {
    swiper,
    swiperSlide,
    mainnav
  },
  data() {
    return {
      prevDisabled: false,
      nextDisabled: false,
      newsId: null,
      arrayKey: null,
      sliderMax: null,
      currentSlide: 1,
      news: news,
      image: null,
      currentProject: null,
      swiperOption: {
        loop: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          autoplay: {
            delay: 2500,
            disableOnInteraction: false
          }
        }
      }
    }
  },
  created() {
    let id = this.$route.params.slug
    this.newsId = parseInt(id)
    this.arrayKey = this.newsId - 1
    this.news.reverse()

    this.currentSlide = this.arrayKey + 1

    const maxValue = this.news.length
    this.sliderMax = maxValue

    if(this.currentSlide === 2) {
      this.prevDisabled = true
    }
    if(this.currentSlide === maxValue - 1) {
      this.nextDisabled = true
    }
  }, 
  computed: {
    currentLocale: function() {
      return this.$i18n.locale
    }
  },
  methods: {
    decreaseCurrentSlide: function() {
      if(this.currentSlide > 1) {
        this.prevDisabled = false
        this.currentSlide = this.currentSlide - 1
        history.pushState({}, null, `/news/${this.currentSlide}`)
      } else {
        this.prevDisabled = true
      }
      this.nextDisabled = false
    },
    increaseCurrentSlide: function() {
      const maxValue = parseInt(this.news.length)
      if(this.currentSlide < maxValue) {
        this.nextDisabled =  false
        this.currentSlide = this.currentSlide + 1
        history.pushState({}, null, `/news/${this.currentSlide}`)
      } else {
        this.nextDisabled = true
      }
      this.prevDisabled = true
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/news/news-article/news-article.js